// Module
var code = "<ns-button id=\"salesEventBtn\" theme$=\"[[theme]]\" disabled$=\"[[disabled]]\" size$=\"[[size]]\" on-tap=\"enterSalesEvent\"> [[buttonText]] </ns-button> ";
// Exports
module.exports = code;